import React from 'react';
import { Formik } from 'formik';
import * as Yup from 'yup';
import { I18n } from 'i18n-js';
import { PERSONAL_EMAIL_REGXP } from '../../shared/Constants';
import OrganizationRegistrationForm from './OrganizationRegistrationForm';
import translations from '../../locales.json';

const i18n = new I18n(translations);
const validationSchema = Yup.object({
  title: Yup.string().required(i18n.t('js.sign_up.organization.registration.validation.title')),
  email: Yup.string()
    .matches(/^([\w-.]+@([\w-]+\.)+[\w-]{2,4})?$/, i18n.t('js.sign_up.organization.registration.validation.email.invalid'))
    .matches(PERSONAL_EMAIL_REGXP, i18n.t('js.sign_up.organization.registration.validation.email.business')),
  website: Yup.string().required(i18n.t('js.sign_up.organization.registration.validation.website')),
  contact: Yup.string().required(i18n.t('js.sign_up.organization.registration.validation.contact')),
  features: Yup.array().of(
    Yup.object().shape({
      id: Yup.number(),
      enable: Yup.boolean(),
    }),
  ).test(
    i18n.t('js.sign_up.organization.registration.validation.test.features'),
    i18n.t('js.sign_up.organization.registration.validation.test.product'),
    arr => arr.filter(Of => Of.enable).length > 3,
  ),
});

const OrganizationRegistration = () => {
  const { featureIds } = window.gon;
  const enableProducts = featureIds.map(f => ({ id: f, enable: true }));
  const values = {
    title: '',
    email: '',
    website: '',
    contact: '',
    country: 'us',
    features: enableProducts,
  };

  return (
    <Formik
      render={formikProps => <OrganizationRegistrationForm {...formikProps} />}
      initialValues={values}
      validationSchema={validationSchema}
    />
  );
};

export default OrganizationRegistration;
